var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "375px",
    height: "240px",
    viewBox: "0 0 375 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_maintenance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MANTENCI\\xD3N",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maintenance",
    transform: "translate(-533.000000, -184.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(127.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_maintenance",
    transform: "translate(408.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "computer",
    transform: "translate(112.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,0 L225,0 C231.075132,-1.11598369e-15 236,4.92486775 236,11 L236,112 L22,112 L22,11 C22,4.92486775 26.9248678,1.11598369e-15 33,0 Z",
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    x: 32,
    y: 10,
    width: 194,
    height: 92,
    rx: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#D8D8D8",
    points: "201 22 205.115724 22 206.622846 24 214 24 214 32 201 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#D8D8D8",
    points: "201 42 205.115724 42 206.622846 44 214 44 214 52 201 52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    fill: "#D8D8D8",
    points: "201 62 205.115724 62 206.622846 64 214 64 214 72 201 72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,112 L254,112 C256.209139,112 258,113.790861 258,116 L258,121 C258,125.970563 253.970563,130 249,130 L9,130 C4.02943725,130 6.08718376e-16,125.970563 0,121 L0,116 C-2.705415e-16,113.790861 1.790861,112 4,112 Z",
    id: "Rectangle-Copy-2",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "crane"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,0 L0,45",
    id: "Line-2",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,0 L234,45",
    id: "Line-3",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round",
    points: "73.9383898 223.062861 58.1327699 202.163364 73.9383898 181.855929 58.1327699 161.548493 73.9383898 141.241058 58.1327699 120.933622 73.9383898 100.626187 58.1327699 80.3187514 73.9383898 60.0113159"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round",
    points: "1.20234113 49 14.9601325 58.0077913 28.7179238 49 42.4757151 58.0077913 56.2335065 49"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-9",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinejoin: "round",
    points: "77.2255826 49 90.277497 58.1519144 103.329411 49 116.381326 58.1519144 129.43324 49 142.485155 58.1519144 155.537069 49 168.588984 58.1519144 181.640898 49 194.692812 58.1519144 207.744727 49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 33,
    y: 222,
    width: 68,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    x: 56,
    y: 47,
    width: 21,
    height: 175
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    x: 62,
    y: 1,
    width: 9,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    strokeLinecap: "round",
    x: 1,
    y: 47,
    width: 232,
    height: 13
  })), /*#__PURE__*/React.createElement("g", {
    id: "window",
    transform: "translate(160.000000, 45.000000)",
    stroke: "#979797",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 0,
    y: 43,
    width: 114,
    height: 80,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,53.5 L114,53.5",
    id: "Line-4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 2,
    cx: 7,
    cy: 48,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    strokeWidth: 2,
    cx: 16,
    cy: 48,
    r: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    strokeWidth: 2,
    fill: "#FFFFFF",
    points: "48 0.512262473 57 0.512262473 57 29 48 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,29 L52.5,43",
    id: "Line-5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "pizza",
    transform: "translate(33.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,48 C37.254834,48 48,37.254834 48,24 C43.4059448,24 30.8119422,24 24,24 C26.7650514,20.2569003 35.5253509,10.0667728 39.2122979,5.43605673 C35.0715671,2.03892791 29.7738921,0 24,0 C10.745166,0 0,10.745166 0,24 C0,37.254834 10.745166,48 24,48 Z",
    id: "Oval",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8077065,0.455669719 L34.3189062,19.0814142 L57.6733746,19.0814142 C57.6535178,11.8416899 56.8010015,4.89446433 48.8077065,0.455669719 Z",
    id: "Path-3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 2,
    cx: 11,
    cy: 29,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    strokeWidth: 2,
    cx: 18,
    cy: 11,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    strokeWidth: 2,
    cx: 49.5,
    cy: 9.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    strokeWidth: 2,
    cx: 20,
    cy: 40,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    strokeWidth: 2,
    cx: 34,
    cy: 31,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00210064,18.4173655 C6.4277434,17.2726089 7.80086968,17.2726089 9.12147948,18.4173655 C10.4420893,19.5621221 11.7455927,19.5621221 13.0319899,18.4173655",
    id: "Path-5",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(9.017045, 18.417365) rotate(24.000000) translate(-9.017045, -18.417365) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0854077,40.8684566 C29.5110504,39.7237 30.8841767,39.7237 32.2047865,40.8684566 C33.5253963,42.0132132 34.8288998,42.0132132 36.1152969,40.8684566",
    id: "Path-5-Copy",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(32.100352, 40.868457) rotate(165.000000) translate(-32.100352, -40.868457) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1668714,15.151755 C42.5925141,14.0069984 43.9656404,14.0069984 45.2862502,15.151755 C46.60686,16.2965116 47.9103635,16.2965116 49.1967606,15.151755",
    id: "Path-5-Copy-2",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(45.181816, 15.151755) rotate(190.000000) translate(-45.181816, -15.151755) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    strokeLinecap: "round",
    points: "17.7139589 20 17 22.3747523 19.8081829 21.634481"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6-Copy",
    strokeLinecap: "round",
    transform: "translate(24.812116, 29.838827) rotate(50.000000) translate(-24.812116, -29.838827) ",
    points: "24.1219829 28.651451 23.408024 31.0262033 26.216207 30.285932"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6-Copy-2",
    strokeLinecap: "round",
    transform: "translate(27.812116, 6.838827) rotate(210.000000) translate(-27.812116, -6.838827) ",
    points: "27.1219829 5.65145099 26.408024 8.02620332 29.216207 7.28593198"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaintenance);
export default __webpack_public_path__ + "static/media/ic_maintenance.a84bf7c1aacf303451ad010ba4484bfb.svg";
export { ForwardRef as ReactComponent };